module.exports = {
    controller: quotaSearchController,
    templateUrl: 'quota/components/quota-search-page.html'
};

quotaSearchController.$inject = [
    '$analytics', 
    '$location',
    '$window',
    'common',
    'quotaDataService'
];

function quotaSearchController(
    $analytics, 
    $location,
    $window,
    common,
    quotaDataService
) {
    var vm = {
    }
    
    return vm;
}